"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _videoCard = require("./videoCard");

var _videoCard2 = _interopRequireDefault(_videoCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _videoCard2.default;